import React, { HTMLInputTypeAttribute } from 'react';
import { InputText } from 'primereact/inputtext';
import { KeyFilterType } from 'primereact/keyfilter';
import { LiliInputBaseProps } from '../LiliMaskedInput/LiliMaskedInput';
import { LiliFloatingLabel } from '../LiliFloatingLabel/LiliFloatingLabel';
import { DEFAULT_INPUT_STYLE, FILLED_INPUT_CLASS } from '../LiliFloatingLabel/consts';

export interface LiliTextInputProps extends LiliInputBaseProps {
  value?: string;
  type?: HTMLInputTypeAttribute;
  filterType?: KeyFilterType;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search' | undefined;
  onChange: (value: string) => void;
  maxLength?: number;
  isOnclearButtonVisible?: boolean;
  disabled?: boolean;
  onClear?: () => void;
}

export const LiliTextInput = ({
  title,
  id,
  value = '',
  errorMessage,
  onBlur,
  onFocus,
  type = 'text',
  filterType,
  inputMode,
  onChange,
  maxLength,
  isOnclearButtonVisible = true,
  disabled,
  onClear,
}: LiliTextInputProps) => {
  const filledStyle = `${FILLED_INPUT_CLASS} ${isOnclearButtonVisible ? 'pr-[28px]' : ''}`;
  return (
    <LiliFloatingLabel
      label={title}
      onClear={() => {
        if (onClear) onClear();
        onChange('');
        if (onBlur) onBlur();
      }}
      isOnclearButtonVisible={isOnclearButtonVisible}
      errorMessage={errorMessage}
      disabled={disabled}
    >
      {/* Full API: https://primereact.org/textnumber/ */}
      <InputText
        className={`${value ? filledStyle : ''} ${DEFAULT_INPUT_STYLE}`}
        placeholder={' '}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(event) => onChange(event.target.value)}
        id={id}
        type={type}
        keyfilter={filterType}
        maxLength={maxLength}
        inputMode={inputMode}
        disabled={disabled}
        readOnly={disabled}
      />
    </LiliFloatingLabel>
  );
};
